/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/. */
import type { Theme } from '@logto/schemas';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

// Videolander supplies its own branding; upstream license notices remain in the source.
const LogtoSignature = (_props: Props) => null;

export default LogtoSignature;
